export const Client1FormData = {
  // Personal details
  firstName: "",
  lastName: "",
  mobile: "",
  email: "",
  dob: null,
  gender: "",
  maritalStatus: "",
  residentStatus: "",
  creditStatus: "",
  homeStatus: "",

  // Address history (3 years)
  address1: "",
  startDate1: null,
  address2: "",
  startDate2: null,
  address3: "",
  startDate3: null,

  // Income details
  salaryWages: "",
  salaryWagesIncome: '0',
  salaryWagesFrequency: "",

  familyAllowance: '0',
  familyAllowanceFrequency: "",

  dividendIncome: '0',
  dividendIncomeFrequency: "",

  companyNetProfit: '0',
  companyNetProfitFrequency: "",

  // Employment history (3 records)
  employment1CompanyName: "",
  employment1Role: "",
  employment1StartDate: null,

  employment2CompanyName: "",
  employment2Role: "",
  employment2StartDate: null,

  employment3CompanyName: "",
  employment3Role: "",
  employment3StartDate: null,
};


export const Client1Errors = {
  // Personal details
  firstName: false,
  lastName: false,
  mobile: false,
  email: false,
  dob: false,
  gender: false,
  maritalStatus: false,
  residentStatus: false,
  creditStatus: false,
  homeStatus: false,

  // Address history (3 years)
  address1: false,
  startDate1: false,
  address2: false,
  startDate2: false,
  address3: false,
  startDate3: false,

  // Income details
  salaryWages: false,
  salaryWagesIncome: false,
  salaryWagesFrequency: false,

  familyAllowance: false,
  familyAllowanceFrequency: false,

  dividendIncome: false,
  dividendIncomeFrequency: false,

  companyNetProfit: false,
  companyNetProfitFrequency: false,

  // Employment history (3 records)
  employment1CompanyName: false,
  employment1Role: false,
  employment1StartDate: false,

  employment2CompanyName: false,
  employment2Role: false,
  employment2StartDate: false,

  employment3CompanyName: false,
  employment3Role: false,
  employment3StartDate: false,
};

export const Client2FormData = {
  // Personal details
  client2FirstName: "",
  client2LastName: "",
  client2Mobile: "",
  client2Email: "",
  client2Dob: null,
  client2Gender: "",
  client2MaritalStatus: "",
  client2ResidentStatus: "",
  client2CreditStatus: "",
  client2HomeStatus: "",

  // Address history (3 years)
  client2Address1: "",
  client2StartDate1: null,
  client2Address2: "",
  client2StartDate2: null,
  client2Address3: "",
  client2StartDate3: null,

  // Income details
  client2SalaryWages: "",
  client2SalaryWagesIncome: '0',
  client2SalaryWagesFrequency: "",

  client2FamilyAllowance: '0',
  client2FamilyAllowanceFrequency: "",

  client2DividendIncome: '0',
  client2DividendIncomeFrequency: "",

  client2CompanyNetProfit: '0',
  client2CompanyNetProfitFrequency: "",

  // Employment history (3 records)
  client2Employment1CompanyName: "",
  client2Employment1Role: "",
  client2Employment1StartDate: null,

  client2Employment2CompanyName: "",
  client2Employment2Role: "",
  client2Employment2StartDate: null,

  client2Employment3CompanyName: "",
  client2Employment3Role: "",
  client2Employment3StartDate: null,
};

export const Client2Errors = {
  // Personal details
  client2FirstName: false,
  client2LastName: false,
  client2Mobile: false,
  client2Email: false,
  client2Dob: false,
  client2Gender: false,
  client2MaritalStatus: false,
  client2ResidentStatus: false,
  client2CreditStatus: false,
  client2HomeStatus: false,

  // Address history (3 years)
  client2Address1: false,
  client2StartDate1: false,
  client2Address2: false,
  client2StartDate2: false,
  client2Address3: false,
  client2StartDate3: false,

  // Income details
  client2SalaryWages: false,
  client2SalaryWagesIncome: false,
  client2SalaryWagesFrequency: false,

  client2FamilyAllowance: false,
  client2FamilyAllowanceFrequency: false,

  client2DividendIncome: false,
  client2DividendIncomeFrequency: false,

  client2CompanyNetProfit: false,
  client2CompanyNetProfitFrequency: false,

  // Employment history (3 records)
  client2Employment1CompanyName: false,
  client2Employment1Role: false,
  client2Employment1StartDate: false,

  client2Employment2CompanyName: false,
  client2Employment2Role: false,
  client2Employment2StartDate: false,

  client2Employment3CompanyName: false,
  client2Employment3Role: false,
  client2Employment3StartDate: false,
};

export const DependentsFormData = {
  dependentName1: '',
  dependentName2: '',
  dependentName3: '',
  dependentName4: '',
  dependentAge1: '',
  dependentAge2: '',
  dependentAge3: '',
  dependentAge4: '',
}

export const DependentsFormErrors = {
  dependentName1: false,
  dependentName2: false,
  dependentName3: false,
  dependentName4: false,
  dependentAge1: false,
  dependentAge2: false,
  dependentAge3: false,
  dependentAge4: false,
}

export const AssetsPropertyFormData = {
  propertyHomeAddress: '',
  propertyEstimatedValue: '',
  propertyDatePurchased: '',
  propertyType: '',
  propertyDetailedType: '',
  propertyRentalIncome: '',
  propertyRentalIncomeDLL: '',
  loanDetailsBorrowTypeDLL: '',
  loanDetailsCurrentMortgage: '',
  loanDetailsLendersName: '',
  loanDetailsRepayType: '',
  loanDetailsRepayment: '',
  loanDetailsMonthlyRepayment: '',
  loanDetailsRepaymentDLL: '',
  loanDetailsInterestRate: '',
  loanDetailsInterestType: '',
  propertyUse: '',
  propertyEquity1: '',
  propertyLVR1: ''
}

export const assetsOtherFormData = {
  otherAssetsCashAndSavings: "",
  superApplicant1: "",
  superApplicant2: "",
  smsf: ""
}

export const AssetsPropertyFormErrors = {
  propertyHomeAddress: false,
  propertyEstimatedValue: false,
  propertyDatePurchased: false,
  propertyType: false,
  propertyDetailedType: false,
  propertyRentalIncome: false,
  propertyRentalIncomeDLL: false,
  loanDetailsBorrowTypeDLL: false,
  loanDetailsCurrentMortgage: false,
  loanDetailsLendersName: false,
  loanDetailsRepayType: false,
  loanDetailsRepayment: false,
  loanDetailsRepaymentDLL: false,
  loanDetailsInterestRate: false,
  loanDetailsInterestType: false,
}

export const AssetsNonPropertyFormData = {
  nonPropertyCashinBank: '0',
  nonPropertyContents: '0',
  nonPropertyBusinessValue: '0',
  nonPropertyCryptoCurrency: '0',
  nonPropertySuperClient1: '0',
  nonPropertySuperClient2: '0',
  nonPropertySMSF: '0',
}

export const AssetsNonPropertyFormErrors = {
  nonPropertyCashinBank: false,
  nonPropertyContents: false,
  nonPropertyBusinessValue: false,
  nonPropertyCryptoCurrency: false,
  nonPropertySuperClient1: false,
  nonPropertySuperClient2: false,
  nonPropertySMSF: false,
}

export const AssetsVehiclesFormData = {
  vehiclesEstimatedValue: '',
  vehiclesMake: '',
  vehiclesYear: '',
  vehiclesCurrentLoan: '',
  vehiclesLendersName: '',
  vehiclesInterestRate: '',
  vehiclesRepayment: '',
  vehiclesRepaymentDLL: '',
}

export const AssetsVehiclesFormErrors = {
  vehiclesEstimatedValue: false,
  vehiclesMake: false,
  vehiclesYear: false,
  vehiclesCurrentLoan: false,
  vehiclesLendersName: false,
  vehiclesInterestRate: false,
  vehiclesRepayment: false,
  vehiclesRepaymentDLL: false,
}

export const LiabilitiesFormData = {
  liabilitiesLiabilityType: "",
  liabilitiesLendersName: "",
  liabilitiesCurrentBalance: "",
  liabilitiesCurrentLimit: "",
  liabilitiesRepayment: "",
  liabilitiesInterestRate: "",
  liabilitiesRepaymentDLL: "",
};

export const LiabilitiesFormErrors = {
  liabilitiesLiabilityType: false,
  liabilitiesLendersName: false,
  liabilitiesCurrentBalance: false,
  liabilitiesCurrentLimit: false,
  liabilitiesRepayment: false,
  liabilitiesInterestRate: false,
  liabilitiesRepaymentDLL: false,
};

export const expenseFormData = {
  childCare_BabySittingAmount: "0",
  childCare_BabySittingFrequency: "",
  childMaintenance_SupportAmount: "0",
  childMaintenance_SupportFrequency: "",
  publicSchoolCosts_Amount: "0",
  publicSchoolCosts_Frequency: "",
  privateSchoolCosts_Amount: "0",
  privateSchoolCosts_Frequency: "",
  higherEducationHECSHELP_Amount: "0",
  higherEducationHECSHELP_Frequency: "",
  food_Amount: "0",
  food_Frequency: "",
  bodyCorporate_Amount: "0",
  bodyCorporate_Frequency: "",
  councilRates_Amount: "0",
  councilRates_Frequency: "",
  electricity_Amount: "0",
  electricity_Frequency: "",
  gas_Amount: "0",
  gas_Frequency: "",
  repairsMaintenance_Amount: "0",
  repairsMaintenance_Frequency: "",
  sewerRates_Amount: "0",
  sewerRates_Frequency: "",
  waterusage_Amount: "0",
  waterusage_Frequency: "",
  buildingInsurance_Amount: "0",
  buildingInsurance_Frequency: "",
  contentsInsurance_Amount: "0",
  contentsInsurance_Frequency: "",
  healthInsurance_Amount: "0",
  healthInsurance_Frequency: "",
  incomeProtection_Amount: "0",
  incomeProtection_Frequency: "",
  lifeInsurance_Amount: "0",
  lifeInsurance_Frequency: "",
  vehicleInsurance_Amount: "0",
  vehicleInsurance_Frequency: "",
  investmentBuildingInsurance_Amount: "0",
  investmentBuildingInsurance_Frequency: "",
  investmentBodyCorporate_Amount: "0",
  investmentBodyCorporate_Frequency: "",
  investmentCouncilRates_Amount: "0",
  investmentCouncilRates_Frequency: "",
  landTax_Amount: "0",
  landTax_Frequency: "",
  investmentRepairsMaintenance_Amount: "0",
  investmentRepairsMaintenance_Frequency: "",
  runningCosts_Amount: "0",
  runningCosts_Frequency: "",
  sewerageRates_Amount: "0",
  sewerageRates_Frequency: "",
  dentalOptical_Amount: "0",
  dentalOptical_Frequency: "",
  medicalHealth_Amount: "0",
  medicalHealth_Frequency: "",
  naturalTherapists_Amount: "0",
  naturalTherapists_Frequency: "",
  board_Amount: "0",
  board_Frequency: "",
  rent_Amount: "0",
  rent_Frequency: "",
  clothingFootwear_Amount: "0",
  clothingFootwear_Frequency: "",
  cosmetics_Amount: "0",
  cosmetics_Frequency: "",
  dryCleaning_Amount: "0",
  dryCleaning_Frequency: "",
  personalCare_Amount: "0",
  personalCare_Frequency: "",
  alcoholTabacco_Amount: "0",
  alcoholTabacco_Frequency: "",
  cinemaConcerts_Amount: "0",
  cinemaConcerts_Frequency: "",
  diningOut_Amount: "0",
  diningOut_Frequency: "",
  giftsMiscellaneous_Amount: "0",
  giftsMiscellaneous_Frequency: "",
  gymSports_Amount: "0",
  gymSports_Frequency: "",
  pets_Amount: "0",
  pets_Frequency: "",
  subscriptions_Amount: "0",
  subscriptions_Frequency: "",
  takeaway_Amount: "0",
  takeaway_Frequency: "",
  travelHolidays_Amount: "0",
  travelHolidays_Frequency: "",
  homeMobilePhone_Amount: "0",
  homeMobilePhone_Frequency: "",
  internet_Amount: "0",
  internet_Frequency: "",
  payTVstreaming_Amount: "0",
  payTVstreaming_Frequency: "",
  petrol_Amount: "0",
  petrol_Frequency: "",
  publicTransport_Amount: "0",
  publicTransport_Frequency: "",
  taxiRideUber_Amount: "0",
  taxiRideUber_Frequency: "",
  tollsParking_Amount: "0",
  tollsParking_Frequency: "",
  vehicleRegistration_Amount: "0",
  vehicleRegistration_Frequency: "",
  vehicleRepairs_Amount: "0",
  vehicleRepairs_Frequency: "",
};


export const expenseFormErrors = {
  childCare_BabySittingAmount: false,
  childCare_BabySittingFrequency: false,
  childMaintenance_SupportAmount: false,
  childMaintenance_SupportFrequency: false,
  publicSchoolCosts_Amount: false,
  publicSchoolCosts_Frequency: false,
  privateSchoolCosts_Amount: false,
  privateSchoolCosts_Frequency: false,
  higherEducationHECSHELP_Amount: false,
  higherEducationHECSHELP_Frequency: false,
  food_Amount: false,
  food_Frequency: false,
  bodyCorporate_Amount: false,
  bodyCorporate_Frequency: false,
  councilRates_Amount: false,
  councilRates_Frequency: false,
  electricity_Amount: false,
  electricity_Frequency: false,
  gas_Amount: false,
  gas_Frequency: false,
  repairsMaintenance_Amount: false,
  repairsMaintenance_Frequency: false,
  sewerRates_Amount: false,
  sewerRates_Frequency: false,
  waterusage_Amount: false,
  waterusage_Frequency: false,
  buildingInsurance_Amount: false,
  buildingInsurance_Frequency: false,
  contentsInsurance_Amount: false,
  contentsInsurance_Frequency: false,
  healthInsurance_Amount: false,
  healthInsurance_Frequency: false,
  incomeProtection_Amount: false,
  incomeProtection_Frequency: false,
  lifeInsurance_Amount: false,
  lifeInsurance_Frequency: false,
  vehicleInsurance_Amount: false,
  vehicleInsurance_Frequency: false,
  investmentBuildingInsurance_Amount: false,
  investmentBuildingInsurance_Frequency: false,
  investmentBodyCorporate_Amount: false,
  investmentBodyCorporate_Frequency: false,
  investmentCouncilRates_Amount: false,
  investmentCouncilRates_Frequency: false,
  landTax_Amount: false,
  landTax_Frequency: false,
  investmentRepairsMaintenance_Amount: false,
  investmentRepairsMaintenance_Frequency: false,
  runningCosts_Amount: false,
  runningCosts_Frequency: false,
  sewerageRates_Amount: false,
  sewerageRates_Frequency: false,
  dentalOptical_Amount: false,
  dentalOptical_Frequency: false,
  medicalHealth_Amount: false,
  medicalHealth_Frequency: false,
  naturalTherapists_Amount: false,
  naturalTherapists_Frequency: false,
  board_Amount: false,
  board_Frequency: false,
  rent_Amount: false,
  rent_Frequency: false,
  clothingFootwear_Amount: false,
  clothingFootwear_Frequency: false,
  cosmetics_Amount: false,
  cosmetics_Frequency: false,
  dryCleaning_Amount: false,
  dryCleaning_Frequency: false,
  personalCare_Amount: false,
  personalCare_Frequency: false,
  alcoholTabacco_Amount: false,
  alcoholTabacco_Frequency: false,
  cinemaConcerts_Amount: false,
  cinemaConcerts_Frequency: false,
  diningOut_Amount: false,
  diningOut_Frequency: false,
  giftsMiscellaneous_Amount: false,
  giftsMiscellaneous_Frequency: false,
  gymSports_Amount: false,
  gymSports_Frequency: false,
  pets_Amount: false,
  pets_Frequency: false,
  subscriptions_Amount: false,
  subscriptions_Frequency: false,
  takeaway_Amount: false,
  takeaway_Frequency: false,
  travelHolidays_Amount: false,
  travelHolidays_Frequency: false,
  homeMobilePhone_Amount: false,
  homeMobilePhone_Frequency: false,
  internet_Amount: false,
  internet_Frequency: false,
  payTVstreaming_Amount: false,
  payTVstreaming_Frequency: false,
  petrol_Amount: false,
  petrol_Frequency: false,
  publicTransport_Amount: false,
  publicTransport_Frequency: false,
  taxiRideUber_Amount: false,
  taxiRideUber_Frequency: false,
  tollsParking_Amount: false,
  tollsParking_Frequency: false,
  vehicleRegistration_Amount: false,
  vehicleRegistration_Frequency: false,
  vehicleRepairs_Amount: false,
  vehicleRepairs_Frequency: false,
};
